import { render, staticRenderFns } from "./TrusteeToTrusteeTransferFormDownload.vue?vue&type=template&id=405145a0&scoped=true"
import script from "./TrusteeToTrusteeTransferFormDownload.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferFormDownload.vue?vue&type=script&lang=ts"
import style0 from "./TrusteeToTrusteeTransferFormDownload.vue?vue&type=style&index=0&id=405145a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405145a0",
  null
  
)

export default component.exports